import { useMutation } from "@tanstack/react-query";

import { updatePhoneNumber } from "~/patients/api/services/settingsService";

export const useUpdatePhoneNumber = () => {
  return useMutation({
    mutationFn: updatePhoneNumber,
  });
};
